module.exports = __webpack_public_path__ + "img/mouse.40c7bd02.svg";